"use client"

import { Button } from "@/components/ui/button"
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { useEditorStore } from "@/lib/editor-store"

export function SessionDisconnectedDialog() {
  const { state, retryCompilerSession } = useEditorStore()
  const open = Boolean(state.sessionDisconnected)
  const retrying = state.sessionPhase === "loading"

  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Session disconnected</AlertDialogTitle>
          <AlertDialogDescription>
            We lost the connection to the compiler session. Please retry to reconnect.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button
            type="button"
            disabled={retrying}
            onClick={() => retryCompilerSession()}
            className="bg-[#5B8CFF] hover:bg-[#4676E5] text-white"
          >
            Retry
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
